// Register filters
import Vue from "vue"
import moment from "moment"

Vue.filter("prettyBytes", function(bytes, decimals, kib) {
  kib = kib || false
  if (bytes === 0) return "0 Bytes"
  if (isNaN(parseFloat(bytes)) && !isFinite(bytes)) return "Not an number"
  const k = kib ? 1024 : 1000
  const dm = decimals != null && !isNaN(decimals) && decimals >= 0 ? decimals : 2
  const sizes = kib
    ? ["Bytes", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB", "BiB"]
    : ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB", "BB"]
  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
})

Vue.filter("pretty", function(value) {
  if (value === undefined) {
    return ""
  }

  const isUrl = obj => {
    try {
      new URL(obj)
      return true
    } catch (_) {
      return false
    }
  }

  const isDate = obj => {
    moment.suppressDeprecationWarnings = true
    return moment(obj).isValid()
  }

  const colorClasses = obj => {
    switch (typeof obj) {
      case "bigint":
      case "number":
        return "sr-prettier-value-integer"

      case "boolean":
        return "sr-prettier-value-boolean"

      case "function":
        return "sr-prettier-value-function"

      case "object":
        if (obj === null) {
          return "sr-prettier-value-null"
        }
        return "sr-prettier-value-object"

      case "string":
        if (isUrl(obj)) {
          return "sr-prettier-value-link"
        }
        if (isDate(obj)) {
          return "sr-prettier-value-date"
        }
        return "sr-prettier-value-string"

      case "undefined":
        return "sr-prettier-value-undefined"

      default:
        return "sr-prettier-value-default"
    }
  }

  const prettier = obj => {
    let html = ""
    if (typeof obj === "object") {
      Object.keys(obj).forEach(key => {
        if (typeof obj[key] === "object" && obj[key] !== null) {
          html += prettier(obj[key])
        } else {
          html += `<li class="sr-prettier-li">
    <span class="sr-prettier-key">${key}</span>
    <span class="sr-prettier-value ${colorClasses(obj[key])}">${obj[key]}</span>
</li>`
        }
      })
    }
    return `<ul class="sr-prettier-ul">${html}</ul>`
  }

  return `<div class="sr-prettier-wrapper">${prettier(value)}</div>`
})
